import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3909a67d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3909a67d&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=3909a67d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3909a67d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserInfoBox: require('/drone/src/components/UserInfoBox/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,BargainSuccessTips: require('/drone/src/components/Bargain/success-tips/index.vue').default})
